<template>
  <div>
    <nav class="bg-white border-b border-gray-100 xl:block lg:block md:block sm:hidden hidden">
      <!-- Primary Navigation Menu -->
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between h-10">
          <div class="flex">
            <!-- Navigation Links -->
            <div class="hidden space-x-8 sm:-my-px sm:flex">
              <jet-nav-link>
                Dashboard
              </jet-nav-link>
              <!-- <jet-nav-link :href="route('tenants.index')" :active="route().current('tenants.index')">
                    Tenancy
                </jet-nav-link> -->
            </div>

            <!--  Dropdown -->
            <div
              class="hidden space-x-8 sm:-my-px sm:ml-5 sm:flex cursor-pointer"
            >
              <div v-for="(value, key) in rmOrder" class="relative">
                <jet-dropdown align="right" width="48">
                  <template #trigger>
                    <div
                      class="
                        inline-flex
                        items-center
                        px-1
                        pt-1
                        border-b-2 border-transparent
                        text-sm
                        font-medium
                        leading-5
                        text-gray-500
                        hover:text-gray-700 hover:border-gray-300
                        focus:outline-none
                        focus:text-gray-700
                        focus:border-gray-300
                        transition
                        h-10
                      "
                    >
                      {{ value.name }}
                    </div>
                  </template>

                  <template #content>
                    <div >
                      <jet-dropdown-link
                        v-for="(value2, key2) in value.items" 
                        v-if="slug!=null"
                        :href="route(value2.url,slug)"                      
                        >
                      <!-- {{rmOrder[key].items}} -->
                      {{  value2.label }}
                      </jet-dropdown-link>

                      <div class="border-t border-gray-100"></div>
                    </div>
                  </template>
                </jet-dropdown>
              </div>
            </div>

            <!--More  Dropdown -->
            <div
              class="hidden space-x-8 sm:-my-px sm:ml-10 sm:flex cursor-pointer">
              <div class="relative">
                <jet-dropdown align="right" width="48">
             
                  <template #trigger>
                    <div
                      class="
                        inline-flex
                        items-center
                        px-1
                        pt-1
                        border-b-2 border-transparent
                        text-sm
                        font-medium
                        leading-5
                        text-gray-500
                        hover:text-gray-700 hover:border-gray-300
                        focus:outline-none
                        focus:text-gray-700
                        focus:border-gray-300
                        transition
                        h-10
                      "
                    >
                      More
                    </div>
                  </template>

                  <template #content>
                    <div v-for="(value2, key2) in rmenuDef">
                      <jet-dropdown-link
                      v-if="slug!=null"
                        :href="route(value2.url,slug)"
                      >
                        {{ value2.label}}
                      </jet-dropdown-link>

                    <jet-dropdown-link
                      v-else
                        :href="route(value2.url)"
                      >
                        {{ value2.name}}
                      </jet-dropdown-link>

                      <div class="border-t border-gray-100"></div>
                    </div>
                  </template>


                </jet-dropdown>
              </div>
            </div>
          </div>

          <!-- Hamburger -->
          <!-- <div class="-mr-2 flex items-center sm:hidden">
            <button
              @click="showingNavigationDropdown = !showingNavigationDropdown"
              class="
                inline-flex
                items-center
                justify-center
                p-2
                rounded-md
                text-gray-400
                hover:text-gray-500 hover:bg-gray-100
                focus:outline-none focus:bg-gray-100 focus:text-gray-500
                transition
              "
            >
              <svg
                class="h-6 w-6"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  :class="{
                    hidden: showingNavigationDropdown,
                    'inline-flex': !showingNavigationDropdown,
                  }"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
                <path
                  :class="{
                    hidden: !showingNavigationDropdown,
                    'inline-flex': showingNavigationDropdown,
                  }"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div> -->
        </div>
      </div>

    
    </nav>
  </div>
</template>

<script>
import JetApplicationMark from "@/Jetstream/ApplicationMark.vue";
import JetBanner from "@/Jetstream/Banner.vue";
import JetDropdown from "@/Jetstream/Dropdown.vue";
import JetDropdownLink from "@/Jetstream/DropdownLink.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";

export default {
  props: {
    title: String,
    scId: String,
    scType: String,
  },

  components: {
    Head,
    JetApplicationMark,
    JetBanner,
    JetDropdown,
    JetDropdownLink,
    JetNavLink,
    JetResponsiveNavLink,
    Link,
  },

  data() {
    return {
      showingNavigationDropdown: false,
      menuDef: new Object(),
      mOrder: new Object(),
      rmenuDef: new Object(),
      rmOrder: new Object(),
      slug:"",
    };
  },

  methods: {
    switchToTeam(team) {
      this.$inertia.put(
        route("current-team.update"),
        {
          team_id: team.id,
        },
        {
          preserveState: false,
        }
      );
    },

    logout() {
      this.$inertia.post(route("logout"));
    },

    getMenuDef() {
      this.errors = {};
      axios
        .get("/menus/menuDef")
        .then((response) => {
          this.menuDef = response.data.menus;
          this.mOrder = response.data.mOrder;
        
        })
        .catch((error) => {
          if (error.response.status === 422) {
            console.log(error);
            //  this.errors = error.response.data.errors || {};
          }
          //alert("error");
        });
    },
    isContain: function (key, obj) {
      return key in obj;
    },

    getRelatedMenuDef($id,$type) {
      this.errors = {};
      axios
        .get("/admin/menus/getRelatedMenuList", {
          params: {
            id: $id,
            type: $type
          },
        })
        .then((response) => {
        //  console.log("getRelatedMenuList Response", response.data);
            this.rmenuDef = response.data.moreArr;
            this.rmOrder = this.convertObjectToArray(response.data.parentArr);
            this.slug = response.data.prefix;
            console.log("MENU RESPonse",this.rmOrder);

        })
        .catch((error) => {
          console.log("Error", this.error);
          // alert("error");
        });
    },
    convertObjectToArray(input) {
      if (typeof input === 'object' && input !== null) {
        if (Array.isArray(input)) {
          // If it's already an array, no need to convert it
          return input;
        } else {
          // Convert the object to an array
          return Object.values(input);
        }
      } else {
        // If it's not an object, return an empty array or handle it as needed
        return [];
      }
    }
  },
  computed: {},
  mounted() {
   // this.getMenuDef();
   //console.log("rlt",this.scId);
    this.getRelatedMenuDef(this.scId,this.scType);
  },
};
</script>

<style>
.mobileMenuStyle{
min-height: 100vh;
background: rgb(226, 141, 141);

}
.navMenuStyle{
  /* padding:0px 12px; */
display: flex;
flex-direction: column;
justify-content: flex-start;
 /* min-height: 100vh; */

text-align: center;
}
.navHomeMenuStyle{
text-align: center;
}

.navMenuStyle .item {
color: white;
/* font-size: 2rem; */
text-decoration: none;
position: relative;
}
.navMenuStyle  i{
padding : 0.1em;
font-size: 1.2rem;
}
.navhMenuStyle .item:hover i{
color: blue;
}
.navMenuStyle .item::after{
content: attr(data-text);
position: absolute;
font-size: 13px;
top: 50%;
white-space: nowrap;
padding:6px;
border-radius: 10px;

visibility: hidden;
opacity: 0;
transition: opacity 0.2s, transform 0.0s;
color: black;
margin-left: 33px;
}
.navMenuStyle .item:hover::after{
visibility: visible;
transform: translate(10px,-50%);
opacity: 1;
}
.item{
margin-top: 1px; 
}
</style>